import { QueryLoader } from "@jsq/ds/core";
import { WorkspaceDashboard } from "./components/WorkspaceDashboard";
import { useFetchWorkspaceRowData } from "./hooks";
import { queryLoader } from "./style_vanilla.css";

export const Dashboard = () => {
  const { response, rowData } = useFetchWorkspaceRowData({ active: true });
  return (
    <div className={queryLoader}>
      <QueryLoader result={response}>
        <WorkspaceDashboard rowData={rowData} />
      </QueryLoader>
    </div>
  );
};
